export const calloutSessionIdConfig = {
  description:
    'Le code d’identification se trouve dans l’alerte de connexion que vous avez reçue par mail\u00A0:',
  imgName: 'session-id.png',
  title: 'Où se trouve le code d’identification\u00A0?',
};
